import { render, staticRenderFns } from "./FormImportStudent.vue?vue&type=template&id=7ea36698"
import script from "./FormImportStudent.vue?vue&type=script&lang=js"
export * from "./FormImportStudent.vue?vue&type=script&lang=js"
import style0 from "./FormImportStudent.vue?vue&type=style&index=0&id=7ea36698&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports